import type { NotificationListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

const toPositiveInteger = (value: unknown): number | undefined => {
	const parsed =
		typeof value === "string" && value.trim() !== "" ? Number(value) : value;
	return typeof parsed === "number" && Number.isInteger(parsed) && parsed > 0
		? parsed
		: undefined;
};

/**
 * Returns every notification id a (possibly merged) row stands for: the row's
 * own id plus all `customContent.notificationIds`. Backend sends an array there
 * even though `customContent` is typed as a bag of scalars.
 */
export const getRowNotificationIdsToMarkRead = (row: {
	id: number;
	customContent?: NotificationListItemResponseDTO["customContent"];
}): number[] => {
	const mergedIds: unknown = row.customContent?.notificationIds;
	const candidates: unknown[] = [
		row.id,
		...(Array.isArray(mergedIds) ? mergedIds : []),
	];
	const ids: number[] = [];
	for (const candidate of candidates) {
		const id = toPositiveInteger(candidate);
		if (id !== undefined && !ids.includes(id)) {
			ids.push(id);
		}
	}
	return ids;
};
